// i18n area 'auth' — locale lv-LV (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.lv-LV.meta.json.
import type { enUS } from './auth'

export const lvLV: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Piesakieties savā kontā',
    username: 'Lietotājvārds',
    usernamePlaceholder: 'Ievadiet lietotājvārdu',
    usernameHint: 'Lietojiet lietotājs@domēns, lai autentificētos direktorija realm',
    continue: 'Turpināt',
    changeUser: 'Tas neesat jūs?',
    password: 'Parole',
    forgotPassword: 'Aizmirsāt paroli?',
    submit: 'Pieteikties',
    otp: 'Vienreizējs kods',
    otpSubtitle: 'Ievadiet kodu no sava autentifikatora',
    otpHint: 'Seši cipari no autentifikācijas lietotnes vai viens no atkopšanas kodiem',
    otpSubmit: 'Pārbaudīt',
    invalidCredentials: 'Nederīgs lietotājvārds vai parole',
    tooManyAttempts: 'Pārāk daudz mēģinājumu — uzgaidiet brīdi un mēģiniet vēlreiz',
    realmUnavailable: 'Realm pašlaik nevar pārbaudīt akreditācijas datus — klastera store nav sasniedzams. Piesakieties kā lokāls lietotājs (break-glass).',
    genericError: 'Pieteikšanās neizdevās — vai TVirt backend ir sasniedzams?'
  },
  user: {
    logout: 'Iziet',
    password: {
      menu: 'Mainīt paroli',
      title: 'Mainiet savu paroli',
      current: 'Pašreizējā parole',
      new: 'Jaunā parole',
      confirm: 'Apstipriniet jauno paroli',
      mismatch: 'Paroles nesakrīt',
      error: 'Neizdevās nomainīt paroli',
      forcedTitle: 'Nomainiet paroli, lai turpinātu',
      forcedHint: 'Šo paroli iestatīja administrators, un tā ir jānomaina pirms ieiešanas.',
      forcedSubmit: 'Mainīt un ieiet'
    },
    mfa: {
      title: 'Divfaktoru autentifikācija',
      subtitle: 'Otrais faktors, ko prasa katrā pieteikšanās reizē',
      loadError: 'Neizdevās ielādēt otrā faktora stāvokli',
      enrolled: 'Aktīvs',
      notEnrolled: 'Nav aktīvs',
      enrolledAt: 'Aktivizēts',
      codesRemaining: 'Atlikušie atkopšanas kodi',
      requiredHint:
        'Administrators pieprasa otro faktoru šim kontam: konfigurējiet to tagad — līdz tam varēsiet pieteikties, bet maz ko citu.',
      enroll: 'Konfigurēt',
      enrollTitle: 'Konfigurēt divfaktoru autentifikāciju',
      enrollHint: 'Noskenējiet šo kodu ar autentifikācijas lietotni, pēc tam ievadiet tās rādīto kodu, lai apstiprinātu.',
      secretHint: 'Neizdodas noskenēt? Ievadiet lietotnē šo slepeno atslēgu:',
      code: 'Kods no lietotnes',
      confirm: 'Apstiprināt',
      startError: 'Neizdevās sākt konfigurāciju',
      confirmError: 'Neizdevās apstiprināt konfigurāciju',
      codesTitle: 'Jūsu atkopšanas kodi',
      codesWarning:
        'Šie kodi tiek parādīti tikai vienu reizi. Saglabājiet tos tagad: katrs no tiem ļauj pieteikties, kad autentifikators nav pieejams, un ir derīgs tikai vienu reizi.',
      codesAck: 'Esmu saglabājis atkopšanas kodus',
      codesDone: 'Gatavs',
      copy: 'Kopēt',
      copied: 'Nokopēts',
      download: 'Lejupielādēt',
      regenerate: 'Jauni atkopšanas kodi',
      regenerateTitle: 'Ģenerēt atkopšanas kodus no jauna',
      regenerateHint: 'Visi līdz šim izsniegtie kodi pārstāj darboties brīdī, kad tiek ģenerēts jaunais komplekts.',
      regenerateConfirm: 'Ģenerēt no jauna',
      regenerateError: 'Neizdevās atkārtoti ģenerēt atkopšanas kodus',
      remove: 'Noņemt',
      removeTitle: 'Noņemt otro faktoru',
      removeConfirm: 'Noņemt',
      removeHint: 'Konts atgriežas pie tikai paroles. Otro faktoru varat konfigurēt no jauna jebkurā brīdī.',
      removeRequiredHint:
        'Administrators pieprasa otro faktoru šim kontam, tāpēc serveris noņemšanu atteiks — vispirms lūdziet atcelt šo prasību.',
      removeError: 'Neizdevās noņemt otro faktoru'
    },
    profile: {
      menu: 'Doties uz manu profilu',
      sessions: 'Aktīvās sesijas',
      sessionsHint: 'Jūsu atvērtās sesijas šajā mezglā',
      sessionsEmpty: 'Nav aktīvu sesiju',
      sessionCreated: 'Pieteikšanās veikta',
      sessionExpires: 'Beidzas',
      revoke: 'Atsaukt sesiju',
      revokeError: 'Neizdevās atsaukt sesiju',
      loadError: 'Neizdevās ielādēt sesijas'
    }
  }
}
